import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, signal} from '@angular/core';
import {ConfigurationHttpService} from "../http-requests/configuration-http.service";
import {TagHttpService} from "../http-requests/tag-http.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ConfigurationDto} from "../models/configuration-dto";
import {HttpErrorResponse} from "@angular/common/http";
import {TagDto} from "../models/tag-dto";
import {OverrideHttpService} from "../http-requests/override-http.service";
import {CbComposition, CbConfig, CbTag} from "../models/configuration-builder";
import {ConfigurationbuilderHttpService} from "../http-requests/configurationbuilder-http.service";
import {PermissionService} from "../_auth/permission.service";
import {ConfigurationSpecial} from "../models/composition/composition-special";
import {AlertLevel} from "../enums/alert-level";
import {GlobalAlertService} from "../_services/global-alert.service";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {FormContainerComponent} from "../_components/form-container/form-container.component";
import {HeaderContainerComponent} from "../_components/header-container/header-container.component";
import {PageContainerComponent} from "../_components/page-container/page-container.component";
import {CheckboxComponent} from "../_ui/components/controls/checkbox/checkbox.component";
import {SelectComponent} from "../_ui/components/controls/select/select.component";
import {KeyboardService} from "../_services/keyboard.service";
import {DropdownComponent} from "../_ui/components/controls/dropdown/dropdown.component";
import {DropdownItemComponent} from "../_ui/components/controls/dropdown-item/dropdown-item.component";
import {IconDirective} from "../_ui/directives/icon/icon.directive";
import copy from "copy-to-clipboard";
import {
  PriceDialogDetail,
  PriceInputDialogComponent
} from "../x-components/price-input-dialog/price-input-dialog.component";

/** What the price dialog on this page is editing: one article's price inside one price profile. */
interface PriceOverrideTarget {
  readonly configuration: CbConfig;
  readonly composition: CbComposition;
}

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  imports: [
    CommonModule, FormsModule, FormContainerComponent, HeaderContainerComponent, PageContainerComponent, CheckboxComponent, SelectComponent, DropdownComponent, DropdownItemComponent, IconDirective,
    PriceInputDialogComponent
  ],
  styleUrls: ['./configurations.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfigurationsComponent implements OnInit {
  public configurations?: ConfigurationDto[];
  public filtered_configurations?: ConfigurationDto[];
  public searchText: string = "";
  public error?: HttpErrorResponse;
  public newConfigurationName: string = "";
  public activeConfiguration?: CbConfig;
  public activeTag?: CbTag;
  public tags?: TagDto[];
  public store: any = {
    _tag: true,
    compositions: []
  };
  public configurationBuild: CbConfig[] = [];
  // Special Setter
  special: ConfigurationSpecial | undefined;

  constructor(private configurationHttpService: ConfigurationHttpService,
              private tagHttpService: TagHttpService,
              private overrideHttpService: OverrideHttpService,
              private cbHttpService: ConfigurationbuilderHttpService,
              private route: ActivatedRoute,
              public router: Router,
              public PermissionService: PermissionService,
              private globalAlertService: GlobalAlertService,
              protected keyboardService: KeyboardService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  //AssignTagCopy(): void {
  //  if (this.tags == undefined) this.tags = [];
  //  this.overridden_tags = this.tags.map(x => Object.assign({}, x));
  //}

  AssignCopy(): void {
    this.filtered_configurations = Object.assign([], this.configurations);
  }

  FilterItem(value: string) {
    this.searchText = value;
    if (!value) {
      this.AssignCopy();
    } else {
      this.filtered_configurations = Object.assign([], this.filtered_configurations?.filter(configuration =>
        configuration.name.toLowerCase().indexOf(value.toLowerCase()) > -1
      ))
    }
  }

  TrackByIndex(index: number, obj: any): any {
    return index;
  }

  AddConfiguration(template: string = ""): void {
    this.cbHttpService.add(this.newConfigurationName, template).subscribe(x => {
      this.configurationBuild.splice(0, 0, x);
      this.SetActiveConfiguration(this.configurationBuild[0]);
      this.newConfigurationName = "";
      this.FilterItem(this.searchText);
      this.globalAlertService.createAlertBannerModel("Hinzufügen erfolgreich", `Das Preisprofil ${x.name} wurde erfolgreich angelegt.`, AlertLevel.success, 2000);
      this.globalAlertService.show();
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Fehler", `Preisprofil konnte nicht hinzugefügt werden.`, AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  CloneConfiguration(configuration: CbConfig) {
    let name = prompt("Neuer Veranstaltungsname:", "");
    this.newConfigurationName = name == null ? "" : name;
    this.AddConfiguration(configuration.id);
  }

  RemoveConfiguration(configuration: CbConfig): void {
    let confirmation = confirm("Löschen des folgenden Preisprofils bestätigen:\n" + configuration.name + "\n" + configuration.id);
    if (!confirmation) return;
    this.configurationHttpService.delete(configuration.id).subscribe(x => {
      this.configurationBuild.splice(this.configurationBuild.indexOf(configuration), 1);
      if (this.configurationBuild.length > 0 && (this.activeConfiguration == undefined || this.activeConfiguration == configuration)) this.activeConfiguration = this.configurationBuild[0];
      this.globalAlertService.createAlertBannerModel("Löschen erfolgreich", `Löschen des Preisprofils ${configuration.name} erfolgreich.`, AlertLevel.success, 2000);
      this.globalAlertService.show();
      //this.FilterItem(this.searchText);
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Fehler", `Das Preisprofil ${configuration.name} konnte nicht gelöscht werden.`, AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  //ToggleComposition(configuration: CbConfig, composition: CbComposition, index: number) {
  //  this.overrideHttpService.overrideComposition(configuration.id, composition.id, composition.active ? null : false).subscribe(x => {
  //  }, error => {
  //    console.error(error);
  //    composition.active = !composition.active;
  //  })
  //}

  ToggleTag(configuration: CbConfig, tag: CbTag, state: boolean | undefined = undefined) {
    let previous = tag.active;
    let next = state == undefined ? !tag.active : state;
    this.overrideHttpService.overrideTag(configuration.id, tag.id, next).subscribe({
      next: _ => {
        tag.active = next
      },
      error: err => {
        console.error(err);
        this.globalAlertService.createAndShow("Fehler", `Die Einstellung konnte nicht gespeichert werden.`, AlertLevel.error);
        tag.active = previous;
      }
    })
  }

  /**
   * The profile and article whose price dialog is open, or `null`. One dialog instance serves every price cell.
   */
  protected readonly priceOverrideTarget = signal<PriceOverrideTarget | null>(null);

  /**
   * Opens the price dialog for one article in one price profile (Bug #809).
   *
   * This used to be `prompt()` + `parseFloat`, and it had two faults. „12,50" was saved as 12 €, because
   * `parseFloat` stops at the comma. And Cancel sent `price: null`, which the server reads as "remove the
   * override", so dismissing the prompt deleted the profile's price. Now Cancel closes the dialog and sends
   * nothing; removing the override is the dialog's own „Auf Standardpreis zurücksetzen" action.
   */
  OverrideCompositionPrice(configuration: CbConfig, composition: CbComposition) {
    this.priceOverrideTarget.set({configuration, composition});
  }

  /** Whether the article has its own price in this profile. The same test the price cell strikes through on. */
  protected HasPriceOverride(composition: CbComposition): boolean {
    return composition.oPrice != composition.price;
  }

  /** The context lines of the price dialog: the profile, the article and the base price being overridden. */
  protected priceOverrideDetails(target: PriceOverrideTarget): PriceDialogDetail[] {
    return [
      {label: 'Preisprofil', text: target.configuration.name},
      {label: 'Artikel', text: target.composition.name},
      {label: 'Standardpreis', amount: target.composition.price}
    ];
  }

  /**
   * Saves the typed price as the profile's override.
   *
   * A price equal to the base price is sent as "no override" (`null`), as the prompt did. An override that
   * matches the base price changes nothing at the register, and keeping it would leave a row the price cell
   * cannot show as overridden (it compares `oPrice` with `price`), so a later base-price change would silently
   * stop reaching this profile.
   */
  protected SavePriceOverride(target: PriceOverrideTarget, price: number): void {
    this.priceOverrideTarget.set(null);
    const {configuration, composition} = target;
    this.SetComposition(configuration, composition, this.activeStateToKeep(composition),
      price === composition.price ? null : price);
  }

  /** Removes the profile's override: exactly what the old prompt's Cancel did, now only on purpose. */
  protected ResetPriceOverride(target: PriceOverrideTarget): void {
    this.priceOverrideTarget.set(null);
    this.SetComposition(target.configuration, target.composition, this.activeStateToKeep(target.composition), null);
  }

  /** Cancel changes nothing. */
  protected CancelPriceOverride(): void {
    this.priceOverrideTarget.set(null);
  }

  /**
   * The `active` value a price write must carry so it does not re-enable a deactivated article: `false` keeps it
   * off, `null` leaves an active one alone. Carried over unchanged from the prompt.
   */
  private activeStateToKeep(composition: CbComposition): boolean | null {
    return !composition.active ? false : null;
  }

  SetComposition(configuration: CbConfig, composition: CbComposition, active: boolean | null = null, price: number | null = null) {
    this.overrideHttpService.overrideComposition(configuration.id, composition.id, active, price).subscribe(x => {
      if (price != null) {
        composition.oPrice = price;
      }
      if (price == null && active == null) {
        composition.oPrice = composition.price;
        composition.active = true;
      }

      configuration.tags.forEach(tag => {
        let comp = tag.compositions.find(x => x.id == composition.id);
        if (comp == undefined) return;

        comp.oPrice = composition.oPrice;
        comp.active = composition.active;
      })
    }, error => {
      console.error(error);
      if (active != null) composition.active = !composition.active;
    })
  }

  SetActiveConfiguration(configuration: CbConfig): void {
    this.activeConfiguration = configuration;
    this.activeTag = this.activeConfiguration.tags.find(x => x.id == this.activeTag?.id);
    if (this.activeTag == null && this.activeConfiguration.tags.length > 0) this.activeTag = this.activeConfiguration.tags[0];
  }

  SetActiveTag(tag: CbTag): void {
    this.activeTag = tag;
  }

  SetActiveTagById(id: string): void {
    this.activeTag = this.activeConfiguration?.tags.find(x => x.id == id);
  }

  ConfigureSpecial(special: ConfigurationSpecial) {
    this.cbHttpService.setSpecial(special).subscribe((x: any) => {
      this.special = undefined;
      this.globalAlertService.createAlertBannerModel("Konfiguration erfolgreich", `Die Einstellungen wurden erfolgreich gespeichert.`, AlertLevel.success, 2000);
      this.globalAlertService.show();
    }, (error: any) => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Konfiguration fehlgeschlagen", `Die Einstellungen konnten nicht gespeichert werden.`, AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  SetSpecialColor(color: string) {
    if (this.special == undefined) return;
    this.special.color = color.replace("#", "");
  }


  LoadData(): void {
    // load configurations for list view
    this.cbHttpService.list().subscribe(x => {
      this.configurationBuild = x;
      if (this.configurationBuild.length > 0) this.activeConfiguration = this.configurationBuild[0];
      else return;
      if (this.activeConfiguration.tags.length > 0) this.activeTag = this.activeConfiguration.tags[0];
    }, error => console.error(error));
  }

  SetActive(configuration: ConfigurationDto, tag: TagDto): void {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {

    });
    this.LoadData();
  }

  protected CopyConfigurationId(configuration: CbConfig) {
    copy(configuration.id)
  }
}
